import { useAuth } from 'oidc-react';
import { useContext } from 'react';
import { LastRouteContext } from 'RoutePreserver/lastRouteProvider';

export const useAuthActions = () => {
  const auth = useAuth();
  const { clearLastRoute } = useContext(LastRouteContext);

  const initiateSignIn = async (): Promise<void> => {
    try {
      await auth.signIn();
    } catch (error) {
      console.error('Signin failed', error);
      alert('Signin failed. Please try again, and contact support if the issue persists.')
    }
  };

  const initiateSilentSignIn = async (): Promise<void> => {
    try {
      await auth.userManager.signinSilent();
    } catch (error) {
      console.error('Silent signin failed', error);
      alert('Silent signin failed. Please refresh, and contact support if the issue persists.')
    }
  };

  const initiateSignOut = async (): Promise<void> => {
    try {
      clearLastRoute();
      await auth.signOutRedirect({
        id_token_hint: auth.userData?.id_token,
        post_logout_redirect_uri: auth.userManager.settings.post_logout_redirect_uri,
      });
    } catch (error) {
      console.error('Signout failed', error);
      alert('Signout failed. Please try again, and contact support if the issue persists.')
    }
  };

  return { initiateSignIn, initiateSilentSignIn, initiateSignOut };
};
